import { CommandService } from './command-service.ts';

/**
 * A single instance of our CommandService that is intended to be used by our ECS
 * Currently we need to make sure that this is properly cleaned up, e.g. when the ECS World using it
 * is destroyed.
 * @example
 * ```typescript
 * import commandService from '@canvas/command/singleton';
 * import { ExampleCommand } from '@canvas/command/example-command'
 *
 * commandService.send(ExampleCommand, { optionalPayload: 'send-it' });
 * ```
 * @see [@atlassian/command](https://bitbucket.org/atlassian/canvas/src/main/packages/command/README.md) for more.
 */
export const commandService = new CommandService();
